import { apiRoutes } from '../config/api'
import type {
  AdminBetaFilters,
  AdminBetaRegistrationsResponse,
  AdminBetaStatsResponse,
} from '../models/AdminBeta'

function buildQuery(filters: Partial<AdminBetaFilters>, includePagination: boolean) {
  const params = new URLSearchParams()

  if (filters.search?.trim()) {
    params.set('search', filters.search.trim())
  }

  if (filters.country) {
    params.set('country', filters.country)
  }

  if (filters.hardware) {
    params.set('hardware', filters.hardware)
  }

  if (includePagination) {
    params.set('page', String(filters.page ?? 1))
    params.set('pageSize', String(filters.pageSize ?? 25))
  }

  const query = params.toString()
  return query ? `?${query}` : ''
}

async function adminRequest<TResponse>(path: string, adminKey: string): Promise<TResponse> {
  const response = await fetch(path, {
    headers: {
      Accept: 'application/json',
      'X-ToneSignature-Admin-Key': adminKey,
    },
  })

  if (response.status === 401) {
    throw new Error('The admin key is invalid or missing.')
  }

  if (!response.ok) {
    throw new Error('The admin dashboard could not load. Please try again.')
  }

  return response.json() as Promise<TResponse>
}

export function getAdminBetaRegistrations(adminKey: string, filters: AdminBetaFilters) {
  return adminRequest<AdminBetaRegistrationsResponse>(
    `${apiRoutes.adminBeta}${buildQuery(filters, true)}`,
    adminKey,
  )
}

export function getAdminBetaStats(adminKey: string) {
  return adminRequest<AdminBetaStatsResponse>(`${apiRoutes.adminBeta}/stats`, adminKey)
}

export async function exportAdminBetaRegistrations(adminKey: string, filters: AdminBetaFilters) {
  const response = await fetch(`${apiRoutes.adminBeta}/export${buildQuery(filters, false)}`, {
    headers: {
      'X-ToneSignature-Admin-Key': adminKey,
    },
  })

  if (response.status === 401) {
    throw new Error('The admin key is invalid or missing.')
  }

  if (!response.ok) {
    throw new Error('The CSV export could not be created. Please try again.')
  }

  return response.blob()
}
